module.exports = "a {\n  color: var(--main-color);\n}\n\ntbody {\n  display:block;\n  height:400px;\n  overflow:auto;\n}\n\nthead, tbody tr {\n  display:table;\n  width:100%;\n  table-layout:fixed;/* even columns width , fix width of table too*/\n}\n\ntable {\n  width:100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/history-modal/history-modal.component.css
// module id = ./src/app/achelos-iot/modals/history-modal/history-modal.component.css
// module chunks = main